import { useEffect, useRef } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import useTitle from "hooks/useTitle";

import useCloseFullScreenModal from "../useCloseFullScreenModal";
import useOriginIntegrationInstallURL from "./useOriginIntegrationInstallURL";

const VCSIntegrationsManageOrigin = () => {
  const { handleOnClose } = useCloseFullScreenModal();
  const { requestInstallURL } = useOriginIntegrationInstallURL();
  const hasRequested = useRef(false);

  useTitle("Set up Origin integration");

  useEffect(() => {
    if (hasRequested.current) {
      return;
    }

    hasRequested.current = true;
    requestInstallURL();
  }, [requestInstallURL]);

  return (
    <FullScreenModal title="Set up Origin integration" onClose={handleOnClose}>
      <PageLoading />
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageOrigin;
